/*
 * File: ServicesApi.ts
 *
 * ServicesApi: RTK Query APIs for the onboarding services.
 * E.g.: tax code, promo code, etc.
 *
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  apiFacadeKeyName,
  apiFacadeKeyValue,
  endpoints,
  getServiceFetcher,
} from "./ApiConfig";
import { TaxCodeFormData } from "./types";
import { transformAxiosToFetchBaseQueryErrorWithLocationRedirect } from "../utils/api.utils";
import { AxiosError } from "axios";

export const servicesApi = createApi({
  reducerPath: "servicesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: endpoints.services,
    prepareHeaders: headers => {
      if (apiFacadeKeyName && apiFacadeKeyValue) {
        headers.set(apiFacadeKeyName, apiFacadeKeyValue);
      }
      return headers;
    },
  }),
  tagTypes: ["Services"],
  endpoints: builder => ({
    generateTaxCode: builder.mutation<{ taxCode: string }, TaxCodeFormData>({
      async queryFn(values) {
        try {
          const res = await getServiceFetcher().post(
            "/taxcode/generate",
            values,
            {
              withCredentials: true,
            },
          );
          return { data: res?.data };
        } catch (e) {
          const error = transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
            e as AxiosError,
          );
          return { error };
        }
      },
    }),
  }),
});

export const { useGenerateTaxCodeMutation } = servicesApi;
